import { LeadSource } from "@hshrimal/salesleg";

export const LeadSourceDisplayMap = new Map<LeadSource, string>([
  ["google", "Google"],
  ["facebook", "Facebook"],
  ["cold_calling", "Cold Calling"],
]);
